// extracted by mini-css-extract-plugin
module.exports = {"root":"ADlZ449X","flexColumnWrapper":"lhHq09ci","verticalLineDivider":"FDPWDyie"};